import React from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import HoneycombImg from '../../images/honeycomb.png';
import { useMedia } from 'use-media';

const Loading = (props) => {
  const isPC = useMedia({ minWidth: '1000px' });

  let LoadingArea;
  if (isPC) {
    LoadingArea = css`

      overflow: hidden;
      color: #555555;
      transition: 1s ease -in -out;
      opacity: ${props.isFieldCreated ? 0 : 1};
      text-align: center;
      height: ${window.innerHeight};
      width: ${window.innerWidth};

      @keyframes rotate-anime {
        0% { transform: rotate(0); }
        100% { transform: rotate(360deg); }
      }

      img {
        animation: rotate-anime 1s ease infinite;
        margin-top: 160px;
        height: 300px;
        width: auto;
      }
    `;
  } else {
    LoadingArea = css`

      overflow: hidden;
      color: #555555;
      transition: 1s ease -in -out;
      opacity: ${props.isFieldCreated ? 0 : 1};
      text-align: center;
      height: ${window.innerHeight};
      width: ${window.innerWidth};

      @keyframes rotate-anime {
        0% { transform: rotate(0); }
        100% { transform: rotate(360deg); }
      }

      img {
        animation: rotate-anime 1s ease infinite;
        margin-top: 0px;
        height: 300px;
        width: auto;
      }
    `;
  }
  return (
    <>
      <div css={LoadingArea}>

        <img src={HoneycombImg} alt="" />
        <div>
          フィールド作成中...
          <br />
          <a href="/">ホーム(作業がリセットされます)</a>
        </div>
      </div>
    </>
  )
}

export default Loading
